import type { Folder } from '@webapp/account/src/resources/survey/folder';
import type { ShareLink } from '@webapp/account/src/resources/survey/state';

import type { ChartGrouping } from '@webapp/common/lib/date';
import { ListPos } from '@webapp/common/lib/ui';
import { QuestionType } from '@webapp/common/resources/survey';

export interface StatFilter {
    from: string;
    to: string;
    chartGrouping: ChartGrouping;
}

export const TMP_NEW_FOLDER_ID = -1;

export const redirect = (link: string): void => {
    try {
        window.location.replace(link);
    } catch (e) {
        console.error(e);
    }
};

// TODO use flat data-structure or recursion
export const findFolder = (folders: Array<Folder>, folderId: number): Folder => {
    let folder: Folder = null;

    folders.some((f) => {
        if (folderId === f.id) {
            folder = f;
            return true;
        }

        return f.children.some((c) => {
            if (folderId === c.id) {
                folder = c;
                return true;
            }
        });
    });

    return folder;
};

export const findRelativePos = (
    items: Array<{
        id: number;
    }>,
    current: number,
    over: number,
): ListPos => {
    const currentIdx = items.findIndex(({ id }) => id === current);
    const overIdx = items.findIndex(({ id }) => id === over);

    if (current === over || currentIdx === overIdx) return ListPos.SAME;
    if (currentIdx < overIdx) return ListPos.AFTER;
    if (currentIdx > overIdx) return ListPos.BEFORE;
};

export const FOLDER_SHOW_COUNT_INC = 5;

export const withTests = (qt: Set<QuestionType>): boolean =>
    qt.has(QuestionType.TEST_FEW_OF_LIST) ||
    qt.has(QuestionType.TEST_ONE_OF_LIST) ||
    qt.has(QuestionType.TEST_TEXT) ||
    qt.has(QuestionType.TEST_RANK);

export const SURVEY_LIST_PER_PAGE = 50;

export const mapShareLink = ({
    ID,
    SURVEY_ID,
    TITLE,
    REWRITE,
    ACTIVE,
    PASSWORD_ACCESS,
    PASSWORD,
    REPORTS,
    ANSWERS,
    DOWNLOAD,
    FILTERS,
    CROSS_TAB,
    COMPARISON,
    SURVEY_RESULTS,
    FILTER_GROUP_ID,
}: {
    ID: number;
    SURVEY_ID: number;
    TITLE: string;
    REWRITE: string;
    ACTIVE: boolean;
    PASSWORD_ACCESS: boolean;
    PASSWORD: string;
    REPORTS: boolean;
    ANSWERS: boolean;
    DOWNLOAD: boolean;
    FILTERS: boolean;
    CROSS_TAB: boolean;
    COMPARISON?: boolean;
    SURVEY_RESULTS: boolean;
    FILTER_GROUP_ID: number;
}): ShareLink => ({
    id: ID,
    surveyId: SURVEY_ID,
    title: TITLE,
    rewrite: REWRITE,
    active: Boolean(ACTIVE),
    passwordAccess: Boolean(PASSWORD_ACCESS),
    password: PASSWORD,
    reports: Boolean(REPORTS),
    answers: Boolean(ANSWERS),
    download: Boolean(DOWNLOAD),
    filters: Boolean(FILTERS),
    crossTab: Boolean(CROSS_TAB),
    comparison: Boolean(COMPARISON),
    surveyResults: Boolean(SURVEY_RESULTS),
    filterGroupId: FILTER_GROUP_ID,
});
